import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CoreService } from '@reenstudio/app/core/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BrandingComponent } from '../sidebar/branding.component';
import { NgFor, NgIf } from '@angular/common';
import { AuthService } from '@reenstudio/app/core/services/auth.service';
import { Cer } from '@reenstudio/app/core/models/cer/cer';
import { permissions } from '@reenstudio/app/shared/permissions/permissions';
import { NgxPermissionsModule } from 'ngx-permissions';
import { StorageService } from '@reenstudio/app/core/services/storage.service';
import { CerChoiceComponent } from '@reenstudio/app/shared/components/cer-choice/cer-choice.component';
import { Site } from '@reenstudio/app/core/models/site/site';
import { UserRole } from '@reenstudio/app/core/enum/user-role';
import { EventService } from '@reenstudio/app/core/services/event-service';
import { SiteApiService } from '@reenstudio/app/core/services/api/site.services';
import { CerService } from '@reenstudio/app/core/services/api/cer.service';
import { UserService } from '@reenstudio/app/core/services/user-service';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface msgs {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    BrandingComponent,
    NgFor,
    NgIf,
    NgxPermissionsModule,
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  protected readonly Permissions = permissions;

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];
  userLevel: UserRole | null;
  userFullName: string | null;
  userEmail: string | null;
  cerList: Cer[];
  siteList: Site[];
  showSiteSelect: boolean = false; // Mostra le select solo se vi è una CER selezionata
  showCerSelect: boolean = false; // Mostra le select solo se vi è un SITE selezionato
  selectedCer: number = 1;
  selectedSite: number = 1;
  reload: number = 0;

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private cerApiService: CerService,
    private siteApiService: SiteApiService,
    private storageService: StorageService
  ) {
    translate.setDefaultLang('en');
    const cer = this.storageService.getCer();
    if (cer !== null) {
      this.selectedCer = cer;
    } else {
      this.selectedCer = 1;
    }

    const site = this.storageService.getSite();
    if (site !== null) {
      this.selectedSite = site;
    } else {
      this.selectedSite = 1;
    }

    this.showCerSelect = Boolean(this.storageService.getCer());
    this.showSiteSelect = Boolean(this.storageService.getSite());
    this.cerApiService.getCers().subscribe({
      next: (cerList) => {
        this.cerList = cerList.data;
      },
    });
    this.siteApiService.getSites().subscribe({
      next: (siteData) => {
        this.siteList = siteData.data;
      },
    });

    this.userFullName = this.storageService.getName();
    this.userEmail = this.storageService.getEmail();
    this.userLevel = this.storageService.getLevel();
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  changeCer(cerId: number) {
    this.storageService.setCer(cerId);
    this.selectedCer = cerId;
    this.storageService.setCer(cerId);
    EventService.changeCer.emit();
  }

  changeSite(siteId: number) {
    this.storageService.setSite(siteId);
    this.selectedSite = siteId;
    EventService.changeSite.emit();
  }

  // modale per apertura della selezione da implementare
  chooseCer() {
    const dialogRef = this.dialog.open(CerChoiceComponent, {
      minWidth: '50%',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res === 'reload') {
          this.reload++;
        }
      },
    });
  }

  notifications: notifications[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'New message received',
      subtitle: 'Salma sent you new message',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'New Payment received',
      subtitle: 'Check your earnings',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'Jolly completed tasks',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
  ];

  msgs: msgs[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Andrew McDownland',
      subtitle: 'Message blocked. Try Again',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'Christopher Jamil',
      subtitle: 'This message cannot be sent',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'Julia Roberts',
      subtitle: 'You are trying to reach location.',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'James Johnson',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Maria Rodriguez',
      subtitle: 'Congrats for your success',
    },
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'Profilo',
      subtitle: 'Impostazioni account',
      link: '/',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-inbox.svg',
      title: 'Messaggi',
      subtitle: 'Lista messaggi ',
      link: '/apps/email/inbox',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-tasks.svg',
      title: 'Rendicontazione',
      subtitle: 'Fatturazione e incentivi',
      link: '/apps/taskboard',
    },
  ];

  logout() {
    this.authService.signOut();
  }
}
